import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { canPromptInstall, promptInstall } from "@/lib/pwaInstall";

/**
 * Drop-in replacement for <Link to="/account">. When the browser has an
 * install prompt ready (Chrome/Edge/Android — never Safari/iOS), clicking
 * triggers that instead of navigating straight to the profile; either way
 * the user ends up on their profile page right after.
 */
export default function ProfileLink({ to = "/account", onClick, children, ...props }) {
  const navigate = useNavigate();

  const handleClick = async (e) => {
    if (canPromptInstall()) {
      e.preventDefault();
      await promptInstall();
      navigate(to);
    }
    onClick?.(e);
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}
